module.exports = __webpack_public_path__ + "static/img/yidi1.78158246.webp";